import React from 'react';
import PropTypes from 'prop-types';
import { generatePath } from 'react-router';
import { Button } from '@els/els-react--button';
import DialogsWithIcon from '@Containers/Dialogs/DialogsWithIcon';
import history from '@AppRoutes/history';
import { paths } from '@AppRoutes/constants';

import './LoginPromptDialog.scss';

export default function LoginPromptDialog(props) {
  const { selfClose } = props;
  const handleRegisterClick = () => {
    selfClose();
    history.push({
      pathname: paths.PRIVATE_REGISTER,
    });
  };

  const handleLoginClick = () => {
    selfClose();
    history.push({
      pathname: generatePath(paths.LOGIN),
    });
  };

  return (
    <DialogsWithIcon
      {...props}
      className="login-prompt-dialog"
      character="!"
      layoutType="info"
      headerClassName="rx-border-none"
      footerClassName="rx-border-none"
      header="Sign in to use supplier preferences"
      size="md"
      footer={
        <div className="els-btn-group-right">
          <Button data-e2e="dialog-register" type="secondary" onClick={handleRegisterClick} className="e2e-dialog-register">
            Register
          </Button>
          <Button data-e2e="dialog-sign-in" type="primary" onClick={handleLoginClick} className="e2e-dialog-signIn">
            Sign in
          </Button>
        </div>
      }>
      To use this feature you need to be a registered user of Reaxys.
    </DialogsWithIcon>
  );
}

LoginPromptDialog.propTypes = {
  selfClose: PropTypes.func.isRequired,
};
